// default group of watchers for all campaigns can toast this to empty array later when we know the system is muy bueno
export const DEFAULT_WATCHERS = ['campaign.updates@snagajob.com'];
